// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_fa-a";
export var fulfillmentFormRail = "_fa-9";
export var headerTitleRow = "_fa-c";
export var orderDetailsWrapper = "_fa-7";
export var orderLinkTrigger = "_fa-2";
export var paymentInformationGrid = "_fa-h";
export var paymentSummaryColumn = "_fa-i";
export var shipmentContainer = "_fa-b";
export var shipmentDetailsMainPane = "_fa-8";
export var shipmentNavigationCard = "_fa-5";
export var shipmentNavigationRail = "_fa-3";
export var shipmentNavigationRailHeader = "_fa-4";
export var shipmentSummaryFact = "_fa-e";
export var shipmentSummaryGrid = "_fa-d";
export var shipmentSummaryMetadataRow = "_fa-f";
export var shipmentSummaryTags = "_fa-g";
export var shipmentWorkspace = "_fa-0";
export var shipmentWorkspaceContent = "_fa-6";
export var shipmentWorkspaceHeader = "_fa-1";